<template>
  <LayoutAdmin>
    <div class="main-content">
      <section class="section">
        <div class="section-header">
          <h1>Master Data Penduduk</h1>
          <div class="section-header-breadcrumb">
            <div class="breadcrumb-item active">
              <a href="#">Home</a>
            </div>
            <div class="breadcrumb-item">
              <a href="#">Kependudukan</a>
            </div>
            <div class="breadcrumb-item">
              Master Data Penduduk
            </div>
          </div>
        </div>

        <div class="section-body">
          <div class="card">
            <div class="card-header">
              <h4 class="d-inline">
                Master Data Penduduk
              </h4>
              <div class="card-header-action">
                <button
                  id="btnTambah"
                  class="btn btn-success"
                  title="Tambah Penduduk"
                  @click="$bvModal.show('modal-tambah-penduduk')"
                >
                  <i class="fa fa-plus mr-2" />Tambah Penduduk
                </button>
                <button
                  id="btnRefresh"
                  class="btn btn-primary"
                  title="Refresh"
                  @click="loadPenduduk"
                >
                  <i class="fa fa-sync" />
                </button>
              </div>
            </div>
            <div
              class="card-body"
              style="overflow:hidden"
            >
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <label for="">Kecamatan</label>
                    <div class="row">
                      <div class="col-md-6">
                        <v-select
                          v-model="filter.id_kecamatan"
                          :options="optionKecamatan"
                          label="nama_kecamatan"
                          :loading="loadingKecamatan"
                          :disabled="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa' || namaRole === 'Operator Kecamatan'"
                          :clearable="false"
                        />
                      </div>
                      <div class="col-md-6">
                        <v-select
                          v-model="filter.id_desa"
                          :options="optionDesa"
                          label="nama_desa"
                          :loading="loadingDesa"
                          :disabled="namaRole === 'Operator Desa' || namaRole === 'Kepala Desa'"
                          :clearable="false"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label for="">Status Akun Penduduk</label>
                    <v-select
                      v-model="filter.user_terdaftar"
                      :options="[{id: 0, label:'Semua'},{id: 1, label:'Terdaftar'},{id: 2, label:'Belum Terdaftar'}]"
                      :clearable="false"
                    />
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label for="">Status Kependudukan</label>
                    <v-select
                      v-model="filter.is_non_permanen"
                      :options="[{id: 99, label:'Semua'},{id: 0, label:'Penduduk Permanen'},{id: 1, label:'Penduduk Non Permanen'}]"
                      :clearable="false"
                    />
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <label class="text-white">s</label><br>
                    <button
                      class="btn btn-primary"
                      @click="loadPenduduk"
                    >
                      <i class="fa fa-filter mr-2" />Filter
                    </button>
                  </div>
                </div>
              </div>
              <hr>
              <PendudukTable
                :items="items" 
                :fields="fields" 
                :meta="meta" 
                :loading="tableLoading"
                @per_page="handlePerPage" 
                @pagination="handlePagination" 
                @search="handleSearch" 
                @sort="handleSort"
                @editPenduduk="editPenduduk"
                @hapusPenduduk="hapusPenduduk"
              />
            </div>
          </div>
        </div>
      </section>
    </div>
    <b-modal
      id="modal-tambah-penduduk"
      title="Tambah Penduduk"
      size="lg"
      hide-footer
    >
      <FormPenduduk
        aksi="tambah"
        @completedProsesPenduduk="completedTambahPenduduk"
      />
    </b-modal>
    <b-modal
      id="modal-edit-penduduk"
      title="Edit Penduduk"
      size="lg"
      hide-footer
    >
      <FormPenduduk
        aksi="edit"
        :penduduk="pendudukShow"
        @completedProsesPenduduk="completedEditPenduduk"
      />
    </b-modal>
  </LayoutAdmin>
</template>

<style scoped>

</style>

<script>
import NProgress from 'nprogress'
import swal from 'sweetalert'
import LayoutAdmin from './../layouts/Admin.vue'
import PendudukTable from './../../components/table/PendudukTable.vue' //IMPORT COMPONENT DATATABLENYA
import FormPenduduk from './../../components/global/FormPenduduk.vue'

export default {
  name: 'App',
  data() {
    return {
      fields: [
        { key: 'no' },
        { key: 'nama_lengkap', label: 'Nama', sortable: true },
        { key: 'nik', label: 'NIK', sortable: true },
        { key: 'alamat', sortable: true },
        { key: 'desa', sortable: true },
        { key: 'terdaftar', label: 'Terdaftar' },
        { key: 'actions', sortable: false, label: 'Aksi' }
      ],
      filter: {
        id_kecamatan: { id_kecamatan: 0, nama_kecamatan: 'SEMUA KECAMATAN' },
        id_desa: { id_desa: 0, nama_desa: 'SEMUA DESA' },
        user_terdaftar: { id: 0, label: 'Semua' }, // 0 = semua, 1 = terdaftar, 2 = tidak terdaftar,
        is_non_permanen: { id: 99, label: 'Semua'}
      },
      filterReady: false, // supaya set filter dulu, baru load data penduduk
      items: [],
      meta: {},
      current_page: 1,
      per_page: 10,
      search: '',
      sortBy: 'created_at',
      sortByDesc: false,
      tableLoading: true,

      pendudukShow: null,
      optionKecamatan: [{
        id_kecamatan: 0,
        nama_kecamatan: 'Semua'
      }],
      optionDesa: [{
        id_desa: 0,
        nama_desa: 'SEMUA DESA'
      }],
      loadingKecamatan: true,
      loadingDesa: false,
    }
  },
  computed: {
    namaRole() {
      return this.$store.getters.getAuthService.currentRole.nama_role
    }
  },
  components: {
    LayoutAdmin, PendudukTable, FormPenduduk
  },
  methods: {
    loadPenduduk() {
      if (!this.filterReady) {
        return false
      }
      this.tableLoading = true
      NProgress.start()
      let button = document.querySelector('#btnRefresh')
      let buttonHtml = button.innerHTML

      button.setAttribute('disabled', true)
      button.innerHTML = '<i class="fa fa-spin fa-sync"></i>'

      let current_page = this.search == '' ? this.current_page : 1

      let data = {
        page: current_page,
        per_page: this.per_page,
        q: this.search,
        sortby: this.sortBy,
        sortbydesc: this.sortByDesc ? 'DESC' : 'ASC',
        id_kecamatan: this.filter.id_kecamatan.id_kecamatan,
        id_desa: this.filter.id_desa.id_desa,
        user_terdaftar: this.filter.user_terdaftar.id,
        is_non_permanen: this.filter.is_non_permanen.id
      }

      if (this.namaRole === 'Operator Desa' || this.namaRole === 'Kepala Desa') {
        data.by_desa = 1
      }
      if (this.namaRole === 'Operator Kecamatan') {
        data.by_kecamatan = 1
      }

      this.$store.dispatch('fetchPenduduk', data).then((response) => {
        // PARSE DATE
        response.data.data.data.forEach(e => {
          let date = new Date(e.created_at)
          let created_at = date.toLocaleDateString('id-ID', { year: 'numeric', month: 'short', day: 'numeric' })
          created_at += ' ' + date.toLocaleTimeString('it-IT')
          e.created_at = created_at
        })
        //JIKA RESPONSENYA DITERIMA
        let getData = response.data.data
        this.items = getData.data //MAKA ASSIGN DATA POSTINGAN KE DALAM VARIABLE ITEMS
        //DAN ASSIGN INFORMASI LAINNYA KE DALAM VARIABLE META
        this.meta = {
          total: getData.total,
          current_page: getData.current_page,
          per_page: getData.per_page,
          from: getData.from,
          to: getData.to
        }
        button.removeAttribute('disabled')
        button.innerHTML = buttonHtml
        NProgress.done()
        this.tableLoading = false
      })
    },
    editPenduduk(data) {
      this.pendudukShow = data
      this.$bvModal.show('modal-edit-penduduk')
    },
    hapusPenduduk(data) {
      swal({
        title: "Konfirmasi",
        text: "Yakin ingin disable penduduk? Hubungi operator jika ingin mengembalikan penduduk.",
        icon: "warning",
        buttons: {
          cancel: "Batal",
          ok: {
            text: "Yakin, disable penduduk",
            value: "ok",
          },
        }
      }).then(val => {
        if (val === 'ok') {
          this.$store.dispatch('hapusPenduduk', this.pendudukShow.id_penduduk).then((res) => {
            if(res.data.status){
              swal({
                title: "Berhasil",
                text: res.data.message,
                icon: "success",
                buttons: "Ok"
              })
            } else {
              swal({
                title: "Gagal",
                text: res.data.message,
                icon: "error",
                buttons: "Ok"
              })
            }
          }).catch(err => {
            swal({
              title: "Gagal",
              text: err.response.data.message,
              icon: "error",
              buttons: "Ok"
            })
          })
        }
      })
    },
    completedTambahPenduduk () {
      this.loadPenduduk()
      this.$bvModal.hide('modal-tambah-penduduk')
    },
    completedEditPenduduk () {
      this.loadPenduduk()
      this.$bvModal.hide('modal-edit-penduduk')
    },
    handlePerPage(val) {
      this.per_page = val
      this.loadPenduduk()
    },
    handlePagination(val) {
      this.current_page = val 
      this.loadPenduduk()
    },
    handleSearch(val) {
      this.search = val 
      this.loadPenduduk()
    },
    handleSort(val) {
      this.sortBy = val.sortBy
      this.sortByDesc = val.sortDesc

      this.loadPenduduk()
    },
    editAkun(data) {
      this.pendudukShow = data.penduduk
    },
    loadKecamatan() {
      this.$store.dispatch('fetchKecamatan', { id_kabupaten: 274 }).then(res => {
        if (res.data.status) {
          let optKec = []
          optKec.push({
            id_kecamatan: 0,
            nama_kecamatan: 'SEMUA KECAMATAN'
          })
          res.data.data.forEach(e => {
            optKec.push(e)
          })
          this.optionKecamatan = optKec
          this.loadingKecamatan = false

          // select kecamatan sesuai role
          if (
            this.namaRole === 'Operator Kecamatan' ||
            this.namaRole === 'Operator Desa' ||
            this.namaRole === 'Kepala Desa'
          ) {
            this.selectKecamatanByRole()
          } else {
            this.filterReady = true
          }
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
      })
    },
    selectKecamatanByRole() {

      let profil = this.$store.getters.getUserProfile
      if (!this.profil) {
        this.$store.dispatch('fetchUserProfile').then(res => {
          profil = this.$store.getters.getUserProfile
          let id_kecamatan_user = profil.desa.id_kecamatan
          let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

          this.filter.id_kecamatan = selectedKecamatan
        })
      } else {
        let id_kecamatan_user = profil.desa.id_kecamatan
        let selectedKecamatan = this.optionKecamatan.find(e => e.id_kecamatan === id_kecamatan_user)

        this.filter.id_kecamatan = selectedKecamatan
      }

    },
    loadDesa() {
      this.loadingDesa = true
      this.$store.dispatch('fetchDesa', { id_kecamatan: this.filter.id_kecamatan.id_kecamatan }).then(res => {
        if (res.data.status) {
          let optDes = []
          optDes.push({
            id_desa: 0,
            nama_desa: 'SEMUA DESA'
          })
          res.data.data.forEach(e => {
            optDes.push(e)
          })
          this.optionDesa = optDes

          this.loadingDesa = false

          if (
            this.namaRole === 'Operator Desa' ||
            this.namaRole === 'Kepala Desa'
          ) {
            this.selectDesaByRole()
          }
        } else {
          swal({
            title: "Gagal",
            text: res.data.message,
            icon: "error",
            buttons: "Ok"
          })
        }
      }).catch(err => {
        // console.log(err)
      })
    },
    selectDesaByRole() {
      let profil = this.$store.getters.getUserProfile
      if (!this.profil) {
        this.$store.dispatch('fetchUserProfile').then(res => {
          profil = this.$store.getters.getUserProfile
          let id_desa_user = profil.id_desa
          let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)

          this.filter.id_desa = selectedDesa
        })
      } else {
        let id_desa_user = profil.id_desa
        let selectedDesa = this.optionDesa.find(e => e.id_desa === id_desa_user)

        this.filter.id_desa = selectedDesa
      }
    }
  },
  mounted() {
    this.loadPenduduk()

    this.loadKecamatan()

  },
  watch: {
    'filter.id_kecamatan': function (newVal) {
      this.loadDesa()
    },
    'filter.id_desa': function (newVal) {
      this.filterReady = true
    },
    filterReady(newVal) {
      if (newVal) {
        this.loadPenduduk()
      }
    }
  }
}
</script>

<style>

</style>
